import React, { useReducer, useEffect, createContext } from "react";
import { treatAppsData, treatNewsData } from "../functions";

const APP_LINK = "/wp-json/wp/v2/system-links/?per_page=100&_embed";
const NEWS_SITE = "/wp-json/wp/v2/posts/";

let initialState = {
  posts: [],
  apps: [],
  loading: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "updateApps":
      return {
        ...state,
        apps: action.apps,
      };
    case "updatePosts":
      return {
        ...state,
        posts: action.posts,
      };
    case "endLoading":
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

const AppContext = createContext(initialState);

function ContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const promises = [];
    if (window.AppInfo.showLinks) {
      promises.push(
        fetch(APP_LINK)
          .then((r) => r.json())
          .then((response) =>
            treatAppsData(response).then((response) =>
              dispatch({ type: "updateApps", apps: response })
            )
          )
          .catch((err) => {
            console.log(err);
          })
      );
    }
    if (window.AppInfo.showNews) {
      promises.push(
        fetch(NEWS_SITE)
          .then((r) => r.json())
          .then((response) =>
            dispatch({ type: "updatePosts", posts: treatNewsData(response) })
          )
          .catch((err) => {
            console.log(err);
          })
      );
    }
    Promise.all(promises).then(() => dispatch({ type: "endLoading" }));
  }, []);

  return (
    <AppContext.Provider value={{ state }}>{children}</AppContext.Provider>
  );
}

export { AppContext, ContextProvider };
